var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.simcSchema.$disabled)?_c('div',{staticClass:"picker"},[_c('v-select',{attrs:{"label-field":"name","value-field":"symbol","disabled":_vm.disabled,"model":_vm.simcSchema,"values":_vm.cities},on:{"input":_vm.setCity}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }